import { useEffect, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { useI18n } from '../i18n/I18nProvider'
import { Footer } from './Footer'
import { Header } from './Header'
import { ChatWidget } from '../components/ChatWidget'

export function AppShell({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()
  const { t } = useI18n()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
    const heading = document.querySelector<HTMLElement>('main h1')
    heading?.focus({ preventScroll: true })
  }, [pathname])

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">{t('common.skipToContent')}</a>
      <Header />
      <main id="main-content" tabIndex={-1}>{children}</main>
      <Footer />
      <ChatWidget />
    </div>
  )
}
